import React from 'react';
import styled from '@emotion/styled';
import { height, space, width } from 'styled-system';

interface EntryIconProps {
  label: string;
  url: string;
}

const ICON_SIZE = 16;

const Icon = styled.img<any>`
  ${height};
  ${width};
  ${space};
`;

const iconStyles = {
  height: ICON_SIZE,
  width: ICON_SIZE,
};

const EntryIcon = ({ label, url }: EntryIconProps) => (
  <Icon loading="lazy" src={url} alt="" mr={label ? 'sp_8' : 'sp_0'} {...iconStyles} />
);

export default EntryIcon;
